<template>
    <div class="row no-gutters">
        <div class="col-12 my-1 my-md-2 national-stats-header-image-wrapper">
            <img v-if="nationalIndexTabStates.nationalJockey" class="national-stats-header-image" :src="getImage('stats-national-jockey-header', 'jpg')">
            <img v-if="nationalIndexTabStates.nationalTrainer" class="national-stats-header-image" :src="getImage('stats-national-trainer-header', 'jpg')">
        </div>
        <div class="col-12 d-flex justify-content-space-evenly statistics-header">
            <div v-bind:class="{'tab-header-clicked': nationalIndexTabStates.nationalJockey}" v-on:click="onNationalJockeyTabClicked('nationalJockey')" class="col-5 col-md-2 text tab-header text-center"><span>JOCKEY</span></div >
            <div v-bind:class="{'tab-header-clicked': nationalIndexTabStates.nationalTrainer}" v-on:click="onNationalJockeyTabClicked('nationalTrainer')" class="col-5 col-md-2 text tab-header text-center"><span>TRAINER</span></div >
        </div>
        <div v-if="nationalIndexTabStates.nationalJockey" class="col-12 p-0">
            <div class="row no-gutters">
                <div style="position: relative;" class="col-12">
                    <div class="table-responsive">
                        <table class="table hot-jockey-table-border">
                            <thead class="thead-dark">
                            <tr class="table-subheader no-border-top">
                                <th colspan="12"></th>
                                <th colspan="6" class="text-center">LAST 30 RIDES</th>
                            </tr>
                            <tr class="no-border-top">
                                <th scope="col">POS</th>
                                <th scope="col">JOCKEY</th>
                                <th scope="col">PRV</th>
                                <th scope="col">RDS</th>
                                <th scope="col">1st</th>
                                <th scope="col">2nd</th>
                                <th scope="col">3rd</th>
                                <th scope="col">4th</th>
                                <th scope="col">STAKES</th>
                                <th scope="col">W%</th>
                                <th scope="col">P%</th>
                                <th scope="col">PREV</th>
                                <th scope="col">RDS</th>
                                <th scope="col">1st</th>
                                <th scope="col">2nd</th>
                                <th scope="col">3rd</th>
                                <th scope="col">W%</th>
                                <th scope="col">P%</th>
                            </tr>
                            </thead>
                            <tbody v-if="(visibleNationalJockeys.length > 0)">
                            <tr class="hot-jockey-table-row-border" v-for="(nationalJockey, index) in visibleNationalJockeys" :key="index">
                                <td scope="row">{{nationalJockey.nationalCount}}</td>
                                <td>{{nationalJockey.name | jtindex}}</td>
                                <td>{{nationalJockey.jockeyTrainerHomeBase}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.rides}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.ridesFirst}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.ridesSecond}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.ridesThird}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.ridesFourth}}</td>
                                <td>{{nationalJockey.stakes | currency('R', 0, { thousandsSeparator: ' ' })}}</td>
                                <td>{{nationalJockey.winPercentage}}</td>
                                <td>{{nationalJockey.placePercentage}}</td>
                                <td>{{nationalJockey.previous || 0}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.lastRides}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.lastRidesFirst}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.lastRidesSecond}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.lastRidesThird}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.lastWinPercentage}}</td>
                                <td class="highlighted-table-cell">{{nationalJockey.lastPlacePercentage}}</td>
                            </tr>
                            </tbody>
                            <tbody v-if="(visibleNationalJockeys.length === 0)">
                            <tr>
                                No Jockeys
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="(visibleNationalJockeys.length >= 8)" class="row no-gutters d-flex justify-content-center">
                        <div class="extra-rows-toggle-button col-12 btn text-center" v-on:click="toggleExtraJockeyRaceResults('jockey')">
                            <img id="extra-rows-down-arrow-jockey" class="extra-rows-down-arrow" :src="getImage('fixtures-dropdown-icon')">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="nationalIndexTabStates.nationalTrainer" class="col-12 p-0">
            <div class="row no-gutters">
                <div style="position: relative;" class="col-12">
                    <div class="table-responsive">
                        <table class="table hot-jockey-table-border">
                            <thead class="thead-dark">
                            <tr class="table-subheader no-border-top">
                                <th colspan="12"></th>
                                <th colspan="6" class="text-center">LAST 30 RIDES</th>
                            </tr>
                            <tr class="no-border-top">
                                <th scope="col">POS</th>
                                <th scope="col">TRAINER</th>
                                <th scope="col">PRV</th>
                                <th scope="col">RNS</th>
                                <th scope="col">1st</th>
                                <th scope="col">2nd</th>
                                <th scope="col">3rd</th>
                                <th scope="col">4th</th>
                                <th scope="col">STAKES</th>
                                <th scope="col">W%</th>
                                <th scope="col">P%</th>
                                <th scope="col">PREV</th>
                                <th scope="col">RDS</th>
                                <th scope="col">1st</th>
                                <th scope="col">2nd</th>
                                <th scope="col">3rd</th>
                                <th scope="col">W%</th>
                                <th scope="col">P%</th>
                            </tr>
                            </thead>
                            <tbody v-if="(visibleNationalTrainers.length > 0)">
                            <tr class="hot-jockey-table-row-border" v-for="(nationalTrainer, index) in visibleNationalTrainers" :key="index">
                                <td scope="row">{{nationalTrainer.nationalCount}}</td>
                                <td>{{nationalTrainer.name | jtindex}}</td>
                                <td>{{nationalTrainer.jockeyTrainerHomeBase}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.rides}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.ridesFirst}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.ridesSecond}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.ridesThird}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.ridesFourth}}</td>
                                <td>{{nationalTrainer.stakes | currency('R', 0, { thousandsSeparator: ' ' })}}</td>
                                <td>{{nationalTrainer.winPercentage}}</td>
                                <td>{{nationalTrainer.placePercentage}}</td>
                                <td>{{nationalTrainer.previous || 0}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.lastRides}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.lastRidesFirst}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.lastRidesSecond}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.lastRidesThird}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.lastWinPercentage}}</td>
                                <td class="highlighted-table-cell">{{nationalTrainer.lastPlacePercentage}}</td>
                            </tr>
                            </tbody>
                            <tbody v-if="(visibleNationalTrainers.length === 0)">
                            <tr>
                                No Trainers
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="(visibleNationalTrainers.length >= 8)" class="row no-gutters d-flex justify-content-center">
                        <div class="extra-rows-toggle-button col-12 btn text-center" v-on:click="toggleExtraTrainerRaceResults('trainer')">
                            <img id="extra-rows-down-arrow-trainer" class="extra-rows-down-arrow" :src="getImage('fixtures-dropdown-icon')">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import jockeyTrainer from '../components/mixins/Jockey-TrainerName'

    export default {
        name: "NationalIndex",
        mixins:[jockeyTrainer],
        data: function () {
            return {
                nationalIndexTabStates: {
                    nationalJockey: true,
                    nationalTrainer: false
                },
                visibleNationalJockeys: [],
                visibleNationalTrainers: [],
                areJockeyResultsExpanded: false,
                areTrainerResultsExpanded: false
            };
        },
        computed: mapState(['nationalStatistics']),
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            onNationalJockeyTabClicked(tabName) {
                if (this.nationalIndexTabStates[tabName]) return;
                for(let tab in this.nationalIndexTabStates) {
                    if(this.nationalIndexTabStates[tab] && tabName === tab) {
                        this.nationalIndexTabStates[tab] = false;
                        return;
                    }
                    this.nationalIndexTabStates[tab] = tab === tabName;
                }
            },
            toggleExtraJockeyRaceResults() {
                const rotationDeg = this.areJockeyResultsExpanded ? '0' : '180';
                document.querySelector(`#extra-rows-down-arrow-jockey`).style.transform = "rotate(" + rotationDeg + "deg)";
                this.areJockeyResultsExpanded = !this.areJockeyResultsExpanded;
                this.visibleNationalJockeys = this.areJockeyResultsExpanded ? this.nationalStatistics.nationalJockeyStats : this.nationalStatistics.nationalJockeyStats.slice(0, 12);
            },
            toggleExtraTrainerRaceResults() {
                const rotationDeg = this.areTrainerResultsExpanded ? '0' : '180';
                document.querySelector(`#extra-rows-down-arrow-trainer`).style.transform = "rotate(" + rotationDeg + "deg)";
                this.areTrainerResultsExpanded = !this.areTrainerResultsExpanded;
                this.visibleNationalTrainers = this.areTrainerResultsExpanded ? this.nationalStatistics.nationalTrainerStats : this.nationalStatistics.nationalTrainerStats.slice(0, 12);
            }
        },
        mounted: function () {
            this.visibleNationalJockeys = this.nationalStatistics.nationalJockeyStats.slice(0, 12);
            this.visibleNationalTrainers = this.nationalStatistics.nationalTrainerStats.slice(0, 12);
        }
    }
</script>

<style scoped>
    .statistics-header {
        background-color: #000000;
    }

    .statistics-title-text {
        font-size: 1.8rem;
    }

    .tab-header {
        font-size: 0.8rem;
        padding: 0.5rem 0;
        font-weight: bold;
    }

    .tab-header:hover {
        cursor: pointer;
    }

    .tab-header-clicked {
        background-color: #FFFFFF;
        color: #000000;
    }

    th {
        font-size: 0.8rem;
        border: none;
        text-decoration: none;
    }

    tr {
        border: none;
        text-decoration: none;
    }

    .highlighted-table-cell {
        background-color: #f2f2f2;
    }

    .extra-rows-toggle-button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25px;
        background-color: #000000;
        padding: 0 !important;
        border: 1px solid #7c7c7c !important;
        margin-bottom: 0.5rem !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    .extra-rows-down-arrow {
        height: 35px;
        font-weight: bolder;
    }

    .hot-jockey-table-border {
        border: 1px solid #000000;
    }

    .hot-jockey-table-row-border {
        border-top: 1px solid #dee2e6;
    }

    .no-border-top {
        border-top-style: hidden;
    }

    .national-stats-header-image-wrapper {
        overflow-x: hidden;
    }

    .national-stats-header-image {
        width: 220%;
    }

    @media (min-width: 768px) {
        .national-stats-header-image {
            width: 100%;
        }

        .tab-header {
            font-size: 1rem;
            padding: 0.5rem 0;
            font-weight: bold;
        }
    }

</style>